
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class Header extends Vue {
  @Prop() title!: string;
}
